import { XsrfResilient } from '@/services/TypedHelpers'
import { log } from '@/services/Log'
import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

export const applyCoupon = XsrfResilient(async ({ couponCode, order }) => {
  log('applyCoupon', { couponCode, order })
  try {
    // Adds a Coupon Code to Checkout. - https://developer.bigcommerce.com/api-reference/storefront/checkouts/checkout-coupons/checkoutscouponsbycheckoutidpost
    const [
      { default: Axios },
      { getCartFromResponse },
      { recoverShippingOptions },
      { standardizeOrderFromResponse },
      { areAllShipmentsAssigned },
    ] = await allPromisesWithRetries(() => [
      import('axios'),
      import('./getCartFromResponse'),
      import('@/services/FramedCheckout/shipmentServices/recoverShippingOptions'),
      import('@/services/Standardizers/standardizeOrderFromResponse'),
      import('@/helpers/areAllShipmentsAssigned'),
    ])
    const { data, status } = (await Axios.post(`/api/storefront/checkouts/${order?.cart?.id}/coupons?include=consignments.availableShippingOptions`, { couponCode }))
    if (status === 200 && !!data) {
      const newCart = getCartFromResponse(data?.cart, order)
      log('applyCoupon -> recoverShippingOptions', { order, newCart })

      const newOrder = await standardizeOrderFromResponse({ order, bigcResponse: data })
      const allShipmentsAssigned = areAllShipmentsAssigned(newOrder)
      log('applyCoupon END', { success: status === 200, newOrder, areAllShipmentsAssigned: allShipmentsAssigned })
      if (!allShipmentsAssigned) {
        return await recoverShippingOptions({ order, newOrder, newCart: newOrder.cart })
      }
      return { success: true, newOrder }
    }
  } catch {
    log('applyCoupon FAILED', { success: false })
    return { success: false }
  }
  log('applyCoupon FAILED', { success: false })
  return { success: false }
})

export default applyCoupon
